import { css, styled } from "@mui/material";

export const CardContainer = styled("div")(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 150px;
    border-radius: 0.5rem;

    ${theme.metricCard?.color
      ? css`
          background: ${theme.metricCard.color};
        `
      : ""}

    backdrop-filter: blur(12px);

    ${theme.breakpoints.up("mobile")} {
      gap: 0.25rem;
      padding: 0.5rem;
    }

    ${theme.breakpoints.up("tablet")} {
      gap: 0.5rem;
      padding: 1rem 0.5rem;
    }

    ${theme.breakpoints.up("desktop")} {
      gap: 0.5rem;
      padding: 0.75rem;
    }
  `,
);

export const CardBackground = styled("div")(
  ({ theme }) => css`
    ${theme.metricCard?.color
      ? css`
          background: ${theme.metricCard.color};
        `
      : ""};
    border-radius: 2rem;
  `,
);
